import React from 'react';

import Container from '../common/Container.jsx';
import Kit from '../utility/Kit.jsx';
import Name from '../utility/Name.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

const ColumnUtilities = {
    updateStyleForDivider: (style, dividers, index, count) => {
        let dividerData = dividers[index];
        if (dividerData && dividerData.width && !Utilities.isNullOrWhitespace(dividerData.width.value)) {
            const value = parseFloat(dividerData.width.value) / 2.0;
            if (!isNaN(value)) {
                style.borderLeftColor = dividerData.color;
                style.borderLeftStyle = 'solid';
                style.borderLeftWidth = `${value}${dividerData.width.unit}`;
            }
        }
        if (index + 1 < count) {
            dividerData = dividers[index + 1];
            if (dividerData && dividerData.width && !Utilities.isNullOrWhitespace(dividerData.width.value)) {
                const value = parseFloat(dividerData.width.value) / 2.0;
                if (!isNaN(value)) {
                    style.borderRightColor = dividerData.color;
                    style.borderRightStyle = 'solid';
                    style.borderRightWidth = `${value}${dividerData.width.unit}`;
                }
            }
        }
    }
}

function Columns(props) {
    const config = props.config || {};
    const blockProps = config.config && config.config.Block || {};
    const dataType = 'layout';

    const columnProps = {};
    const columnDividers = {};
    const headerDividers = {};
    let width;
    const blockStyle = Utilities.Config.getStyle(blockProps, props.style, (propName, propValue, _style) => {
        const index = propName.indexOf('-');
        if (index < 0) {
            switch (propName) {
                case 'columnCount':
                    return true;
            }
            // Let the utility method process the property as normal
            return false;
        }
        const _propName = propName.substring(0, index);
        const columnId = propName.substring(index + 1);
        const dividerId = columnId.replace('col', '') - 1;
        if (!columnDividers[dividerId]) {
            columnDividers[dividerId] = {};
        }
        if (!headerDividers[dividerId]) {
            headerDividers[dividerId] = {};
        }
        const colProps = columnProps[columnId] || {};
        const colStyle = colProps.style || {};
        const headerStyle = colProps.headerStyle || {};
        switch (_propName) {
            case 'alignment':
                Utilities.Config.updateStyleAlignment(propValue, colStyle);
                break;
            case 'alignmentHeader':
                Utilities.Config.updateStyleAlignment(propValue, headerStyle);
                break;
            case 'backgroundColorHeader':
                headerStyle.backgroundColor = propValue;
                break;
            case 'collapseIfEmpty':
            case 'designHeader':
                colProps[_propName] = propValue;
                break;
            case 'dividerColor':
                columnDividers[dividerId].color = propValue;
                break;
            case 'dividerColorHeader':
                headerDividers[dividerId].color = propValue;
                break;
            case 'dividerWidth':
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    columnDividers[dividerId].width = propValue;
                }
                break;
            case 'dividerWidthHeader':
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    headerDividers[dividerId].width = propValue;
                }
                break;
            case 'paddingBottomHeader':
            case 'paddingLeftHeader':
            case 'paddingRightHeader':
            case 'paddingTopHeader':
                let value = undefined;
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    value = `${propValue.value}${propValue.unit}`;
                }
                headerStyle[_propName.replace('Header', '')] = value;
                break;
            case 'width':
                if (propValue != undefined && !Utilities.isNullOrWhitespace(propValue.value)) {
                    width = propValue.value;
                    if (propValue.unit == '%') {
                        width = `${width}%`;
                    }
                    colProps.width = width;
                } else {
                    colProps.width = undefined;
                }
            // Intentional fallthrough
            default:
                let _propValue;
                if (propValue != undefined && propValue.unit) {
                    _propValue = !Utilities.isNullOrWhitespace(propValue.value) ? `${propValue.value}${propValue.unit}` : undefined;
                } else if (!Utilities.isNullOrWhitespace(propValue)) {
                    _propValue = propValue;
                }
                // Set the property value in the specific column's style
                colStyle[_propName] = _propValue;
                break;
        }
        colProps.style = colStyle;
        colProps.headerStyle = headerStyle;
        columnProps[columnId] = colProps;
        return true;
    });
    let hasHeaderData = false;
    const headers = [];
    const columns = props.columns || config.blocks || [];
    const columnsData = columns.map((column, i) => {
        let columnDataVisible = false;
        const columnData = [];
        if (column) {
            column.forEach((d) => {
                const Component = props.onComponent(d, undefined, props.typeHandler);
                if (!Component) {
                    return;
                }
                columnData.push(Component);

                if (props.forceVisibility) {
                    columnDataVisible = true;
                } else if (props.visibility && d.config && d.config.Block && d.config.Block.design) {
                    let _content = Utilities.getHTMLContent(d.config.Block.design);
                    for (let id in props.visibility) {
                        if (props.visibility[id]) {
                            continue;
                        }
                        const searchString = `{${id}`;
                        const startIndex = _content.indexOf(searchString);
                        if (startIndex < 0) {
                            continue;
                        }
                        const endIndex = _content.indexOf('}', startIndex);
                        if (endIndex < 0) {
                            continue;
                        }
                        _content = _content.substring(0, startIndex) + _content.substring(endIndex + 1);
                    }
                    if (_content.length > 0) {
                        columnDataVisible = true;
                    }
                } else if (Utilities.Config.getVisibility(Component.props.config)) {
                    columnDataVisible = true;
                }
            });
        }
        const columnId = `col${i + 1}`;
        const _columnProps = columnProps[columnId] || {};
        if (!props.builder && !columnDataVisible && _columnProps.collapseIfEmpty) {
            return;
        }
        if (!Utilities.isHTMLContentEmpty(_columnProps.designHeader)) {
            hasHeaderData = true;
        }
        const headerStyle = _columnProps.headerStyle || {};
        ColumnUtilities.updateStyleForDivider(headerStyle, headerDividers, i, blockProps.columnCount);

        let separator;
        if (props.builder) {
            headerStyle.position = 'relative';
            if (i < blockProps.columnCount - 1) {
                separator = <div key={`sep-${columnId}`} className="drag-outline-layout-child" style={{ right: headerStyle.borderRightWidth ? `-${headerStyle.borderRightWidth}` : 0, zIndex: 1 }} />
            }
        }
        if (blockStyle) {
            if (i == 0) {
                headerStyle.borderLeftColor = blockStyle.borderLeftColorHeader;
                headerStyle.borderLeftStyle = blockStyle.borderLeftStyleHeader;
                headerStyle.borderLeftWidth = blockStyle.borderLeftWidthHeader;
            } else if (i == blockProps.columnCount - 1) {
                headerStyle.borderRightColor = blockStyle.borderRightColorHeader;
                headerStyle.borderRightStyle = blockStyle.borderRightStyleHeader;
                headerStyle.borderRightWidth = blockStyle.borderRightWidthHeader;
            }
        }
        headers.push(
            <td key={columnId} className="layout-header" style={headerStyle}>
                <div dangerouslySetInnerHTML={{ __html: Kit.updateDesign(_columnProps.designHeader, props.kit) }} />
                {separator}
            </td>
        );
        // let columnProps = {};
        // if (props.onColumnProps) {
        //     columnProps = props.onColumnProps(i) || {};
        // }
        return (
            <Column
                key={i}
                blockStyle={blockStyle}
                blockType={props.blockType}
                builder={props.builder}
                columnCount={blockProps.columnCount}
                columnData={columnData}
                columnDataVisible={columnDataVisible}
                dataType={dataType}
                dividers={columnDividers}
                dragging={props.dragging}
                forceVisibility={props.forceVisibility}
                id={`${config.id}-child-${i}`}
                index={i}
                onDragEnter={props.onDragEnter}
                {..._columnProps} />
        );
    });
    // let hasColumnData = false;
    // for (let i = 0; i < columns.length; i++) {
    //     if (columns[i].length > 0) {
    //         hasColumnData = true;
    //         break;
    //     }
    // }
    let minHeight, rowStyle;
    if (config.config && config.config.Style && config.config.Style.minHeight) {
        minHeight = `${config.config.Style.minHeight.value}${config.config.Style.minHeight.unit}`;
        rowStyle = { height: minHeight };
    }
    const styleLayoutSpacer = { height: props.builder ? '0.01px' : '0px', maxHeight: props.builder ? '0.01px' : '0px' };
    if (!Utilities.isNullOrWhitespace(blockStyle.borderTopWidth)) {
        styleLayoutSpacer.borderBottomColor = blockStyle.borderTopColor;
        styleLayoutSpacer.borderBottomStyle = blockStyle.borderTopStyle;
        styleLayoutSpacer.borderBottomWidth = blockStyle.borderTopWidth;
    }
    if (!Utilities.isNullOrWhitespace(blockStyle.spacing)) {
        styleLayoutSpacer.paddingTop = blockStyle.spacing;
    }
    let borderBottom;
    if (!Utilities.isNullOrWhitespace(blockStyle.borderBottomWidth)) {
        borderBottom = <tr><td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColor, borderBottomStyle: blockStyle.borderBottomStyle, borderBottomWidth: blockStyle.borderBottomWidth }} /></tr>
    }
    let className = 'layout';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (props.avoidPageBreaks) {
        className += ' pageBreakInsideAvoid';
    }
    let content = (
        <>
            <Container
                bodyProps={props.builder ? { style: { position: 'relative' } } : undefined}
                builder={props.builder}
                className={className}
                colSpan={columns.length}
                config={props.config}
                dataType={dataType}
                onClick={props.onClick}
                onDragStart={props.onDragStart}>
                {props.children}
                {
                    props.builder &&
                    <tr className="builder__controls">
                        <td className="builder__controls--label" colSpan={columns.length}>
                            <div>{props.blockType ? 'CONTAINER' : 'COLUMNS'}</div>
                        </td>
                    </tr>
                }
                {
                    props.renderHeader != false &&
                    hasHeaderData &&
                    <>
                        {
                            !Utilities.isNullOrWhitespace(blockStyle.borderTopWidthHeader) &&
                            <tr>
                                <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderTopColorHeader, borderBottomStyle: blockStyle.borderTopStyleHeader, borderBottomWidth: blockStyle.borderTopWidthHeader }} />
                            </tr>
                        }
                        <tr>
                            {headers}
                        </tr>
                        {
                            !Utilities.isNullOrWhitespace(blockStyle.borderBottomWidthHeader) &&
                            <tr>
                                <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColorHeader, borderBottomStyle: blockStyle.borderBottomStyleHeader, borderBottomWidth: blockStyle.borderBottomWidthHeader }} />
                            </tr>
                        }
                        <tr>
                            {
                                columnsData.map((_, i) => <td key={i} className="layout-spacer" style={styleLayoutSpacer} />)
                            }
                        </tr>
                    </>
                }
                {
                    !Utilities.isNullOrWhitespace(blockStyle.borderTopWidth) &&
                    <tr>
                        <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColor, borderBottomStyle: blockStyle.borderBottomStyle, borderBottomWidth: blockStyle.borderBottomWidth }} />
                    </tr>
                }
                <tr style={rowStyle}>
                    {columnsData}
                    {
                        props.builder &&
                        <td><div className="drag-outline drag-outline-layout drag-outline-layout-parent" /></td>
                    }
                </tr>
                {
                    !Utilities.isNullOrWhitespace(blockStyle.borderBottomWidth) &&
                    <tr>
                        <td colSpan={columnsData.length} style={{ borderBottomColor: blockStyle.borderBottomColor, borderBottomStyle: blockStyle.borderBottomStyle, borderBottomWidth: blockStyle.borderBottomWidth }} />
                    </tr>
                }
            </Container>
            {
                props.builder == true &&
                props.dragging &&
                <div id={`${config.id}-hidden`}
                    className="hidden draggable"
                    data-type={dataType}
                    onDragEnter={props.onDragEnter} />
            }
        </>
    );
    // if (props.builder) {
    //     content = <div style={{ position: 'relative' }}>{content}</div>
    // }
    return content;
}

function Column(props) {
    let width = props.width;
    const style = props.style ? { ...props.style } : {};
    ColumnUtilities.updateStyleForDivider(style, props.dividers, props.index, props.columnCount);
    const isLast = props.index == props.columnCount - 1;
    if (props.blockStyle) {
        if (props.index == 0) {
            style.borderLeftColor = props.blockStyle.borderLeftColor;
            style.borderLeftStyle = props.blockStyle.borderLeftStyle;
            style.borderLeftWidth = props.blockStyle.borderLeftWidth;
        } else if (isLast) {
            style.borderRightColor = props.blockStyle.borderRightColor;
            style.borderRightStyle = props.blockStyle.borderRightStyle;
            style.borderRightWidth = props.blockStyle.borderRightWidth;
        }
    }
    const hasColumnData = props.columnData.length > 0;
    let className = 'layout-cont';
    if (props.builder) {
        className += ' layout-child';
        style.position = 'relative';

        if (!hasColumnData) {
            style.verticalAlign = 'top';
        }
    } else if (!props.columnDataVisible && props.collapseIfEmpty) {
        style.minWidth = 0;
        style.paddingBottom = 0;
        style.paddingLeft = 0;
        style.paddingRight = 0;
        style.paddingTop = 0;
        style.width = 0;
        width = 0;
    }
    return (
        <td
            id={props.id}
            className={className}
            data-block-type={props.blockType || Name.Block.Columns}
            data-type={props.dataType}
            style={style}
            width={width}>

            {
                props.builder &&
                <>
                    {
                        props.parentStyle &&
                        props.parentStyle.paddingTop &&
                        <div className="drag-outline-layout-child drag-outline-layout-child-top" />
                    }
                    {
                        !isLast &&
                        <div className="drag-outline-layout-child" style={{ right: style.borderRightWidth ? `-${style.borderRightWidth}` : 0, zIndex: 1 }} />
                    }
                    {
                        props.dragging &&
                        <div id={`${props.id}-hidden-first`}
                            className="hidden hidden-child-first draggable"
                            data-type={props.dataType}
                            onDragEnter={props.onDragEnter} />
                    }
                </>
            }
            {props.columnData}
            {
                props.builder &&
                <>
                    {
                        !hasColumnData &&
                        !props.dragging &&
                        Utilities.Builder.emptyBlockPlaceholder()
                    }
                    {
                        props.dragging &&
                        <div id={`${props.id}-hidden`}
                            className="hidden hidden-child-last draggable"
                            data-type={props.dataType}
                            style={!hasColumnData && props.dragging ? { marginTop: '10px' } : undefined}
                            onDragEnter={props.onDragEnter} />
                    }
                    {
                        props.parentStyle &&
                        props.parentStyle.paddingBottom &&
                        <div className="drag-outline-layout-child drag-outline-layout-child-bottom" />
                    }
                </>
            }
        </td>
    );
}

const TypeConfig = {
    options: {
        column: (column, visible) => {
            const group = `col${column}`;
            const relatedProperty = column > 1 ? 'columnCount' : undefined;
            const options = [
                {
                    display: `Column ${column}`,
                    group,
                    id: `${group}Props`,
                    type: 'tab',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Collapse If Empty',
                    fullWidth: true,
                    group,
                    name: `collapseIfEmpty-${group}`,
                    relatedProperty,
                    type: 'checkbox',
                    value: false,
                    visible
                },
                {
                    display: 'Header Configuration',
                    group,
                    id: `headerProps-${group}`,
                    type: 'header',
                    visible
                },
                {
                    default: {
                        '2': column > 1 ? undefined : 'tl',
                        '3': column > 2 ? undefined : 'tl',
                        '4': column > 3 ? undefined : 'tl',
                        '5': column > 4 ? undefined : 'tl',
                        '6': column > 5 ? undefined : 'tl'
                    },
                    display: 'Align Header',
                    group,
                    name: `alignmentHeader-${group}`,
                    relatedProperty,
                    type: 'alignment',
                    value: 'tl',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Background Color',
                    group,
                    name: `backgroundColorHeader-${group}`,
                    relatedProperty,
                    type: 'color',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Header Design',
                    fullWidth: true,
                    group,
                    name: `designHeader-${group}`,
                    relatedProperty,
                    type: 'rich-text-collateral-short',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                    display: 'Header Padding',
                    group,
                    name: `paddingMarginHeader-${group}`,
                    nameSuffix: `Header-${group}`,
                    options: _TypeConfig.dropdown.measurement(),
                    relatedProperty,
                    type: 'paddingMargin',
                    visible
                }
            ];
            if (column > 1) {
                options.push(
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Header Divider Width',
                        group,
                        name: `dividerWidthHeader-${group}`,
                        options: _TypeConfig.dropdown.measurement(),
                        relatedProperty: 'columnCount',
                        type: 'measurement',
                        visible
                    },
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Header Divider Color',
                        group,
                        name: `dividerColorHeader-${group}`,
                        relatedProperty: 'columnCount',
                        type: 'color',
                        visible
                    }
                )
            }
            options.push(
                {
                    display: 'Content Configuration',
                    expanded: true,
                    group,
                    id: `contentProps-${group}`,
                    type: 'header',
                    visible
                },
                {
                    default: {
                        '2': column > 1 ? undefined : 'tl',
                        '3': column > 2 ? undefined : 'tl',
                        '4': column > 3 ? undefined : 'tl',
                        '5': column > 4 ? undefined : 'tl',
                        '6': column > 5 ? undefined : 'tl'
                    },
                    display: 'Align Content',
                    group,
                    name: `alignment-${group}`,
                    type: 'alignment',
                    relatedProperty,
                    value: 'tl',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Background Color',
                    group,
                    name: `backgroundColor-${group}`,
                    relatedProperty,
                    type: 'color',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                    display: 'Padding',
                    group,
                    name: `paddingMargin-${group}`,
                    nameSuffix: `-${group}`,
                    options: _TypeConfig.dropdown.measurement(),
                    relatedProperty,
                    type: 'paddingMargin',
                    visible
                },
                {
                    fullWidth: true,
                    group,
                    type: 'spacer-short',
                    visible
                },
                {
                    default: {
                        '2': undefined,
                        '3': undefined,
                        '4': undefined,
                        '5': undefined,
                        '6': undefined
                    },
                    display: 'Minimum Width',
                    fullWidth: true,
                    group,
                    name: `minWidth-${group}`,
                    options: _TypeConfig.dropdown.measurement(true),
                    relatedProperty,
                    type: 'measurement-slider',
                    visible
                },
                {
                    default: {
                        '2': { unit: '%', value: '50' },
                        '3': { unit: '%', value: '33.33' },
                        '4': { unit: '%', value: '25' },
                        '5': { unit: '%', value: '20' },
                        '6': { unit: '%', value: '16.67' }
                    },
                    display: 'Width',
                    fullWidth: true,
                    group,
                    name: `width-${group}`,
                    options: _TypeConfig.dropdown.measurement(true),
                    relatedProperty: 'columnCount',
                    relatedPropertyOverridable: true,
                    type: 'measurement-slider',
                    value: { unit: '%', value: '50' },
                    visible
                }
            );
            if (column > 1) {
                options.push(
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Column Divider Width',
                        group,
                        name: `dividerWidth-${group}`,
                        options: _TypeConfig.dropdown.measurement(),
                        relatedProperty: 'columnCount',
                        type: 'measurement',
                        visible
                    },
                    {
                        default: {
                            '2': undefined,
                            '3': undefined,
                            '4': undefined,
                            '5': undefined,
                            '6': undefined
                        },
                        display: 'Column Divider Color',
                        group,
                        name: `dividerColor-${group}`,
                        relatedProperty: 'columnCount',
                        type: 'color',
                        visible
                    }
                )
            }
            return options;
        }
    },
    panel: {
        block: (contentType) => {
            const group = 'block';
            const options = [
                {
                    display: 'Column Count',
                    group,
                    name: 'columnCount',
                    options: [
                        { display: '2', value: '2' },
                        { display: '3', value: '3' },
                        { display: '4', value: '4' },
                        { display: '5', value: '5' },
                        { display: '6', value: '6' }
                    ],
                    relatedProperties: [
                        'alignment-col2',
                        'alignment-col3',
                        'alignment-col4',
                        'alignment-col5',
                        'alignment-col6',
                        'backgroundColor-col2',
                        'backgroundColor-col3',
                        'backgroundColor-col4',
                        'backgroundColor-col5',
                        'backgroundColor-col6',
                        'borderLeftColor-col2',
                        'borderLeftColor-col3',
                        'borderLeftColor-col4',
                        'borderLeftColor-col5',
                        'borderLeftColor-col6',
                        'borderLeftWidth-col2',
                        'borderLeftWidth-col3',
                        'borderLeftWidth-col4',
                        'borderLeftWidth-col5',
                        'borderLeftWidth-col6',
                        'collapseIfEmpty-col2',
                        'collapseIfEmpty-col3',
                        'collapseIfEmpty-col4',
                        'collapseIfEmpty-col5',
                        'collapseIfEmpty-col6',
                        'minWidth-col2',
                        'minWidth-col3',
                        'minWidth-col4',
                        'minWidth-col5',
                        'minWidth-col6',
                        'paddingMargin-col2',
                        'paddingMargin-col3',
                        'paddingMargin-col4',
                        'paddingMargin-col5',
                        'paddingMargin-col6',
                        'width-col1',
                        'width-col2',
                        'width-col3',
                        'width-col4',
                        'width-col5',
                        'width-col6'
                    ],
                    type: 'dropdown',
                    value: '2'
                }
            ];
            switch (contentType) {
                case Name.Content.ArtistBioItem:
                case Name.Content.CertificateItem:
                case Name.Content.ConsignmentLineItem:
                case Name.Content.CreditLineItem:
                case Name.Content.InvoiceLineItem:
                case Name.Content.PaymentLineItem:
                case Name.Content.PricelistInventoryItem:
                case Name.Content.PurchaseOrderLineItem:
                case Name.Content.TearsheetItem:
                    options.push({
                        display: 'Only Show Header On First Item',
                        fullWidth: true,
                        group,
                        name: 'renderHeaderOnlyFirst',
                        type: 'checkbox',
                        value: false
                    })
                    break;
            }
            options.push(
                {
                    display: 'Header Border',
                    group,
                    name: 'borderHeader',
                    nameSuffix: 'Header',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'border'
                },
                {
                    group,
                    type: 'spacer-short'
                },
                {
                    display: 'Spacing Between Header and Content',
                    fullWidth: true,
                    group,
                    name: 'spacing',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'measurement-slider'
                },
                {
                    group,
                    type: 'spacer-short'
                },
                {
                    display: 'Content Border',
                    group,
                    name: 'border',
                    options: _TypeConfig.dropdown.measurement(),
                    type: 'border'
                },
                ...TypeConfig.options.column(1),
                ...TypeConfig.options.column(2, TypeConfig.visibility.hasAtLeast2Columns),
                ...TypeConfig.options.column(3, TypeConfig.visibility.hasAtLeast3Columns),
                ...TypeConfig.options.column(4, TypeConfig.visibility.hasAtLeast4Columns),
                ...TypeConfig.options.column(5, TypeConfig.visibility.hasAtLeast5Columns),
                ...TypeConfig.options.column(6, TypeConfig.visibility.hasAtLeast6Columns)
            );
            return {
                group,
                label: 'Design',
                options
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, undefined, {})
    },
    visibility: {
        hasAtLeast2Columns: (config) => config.Block && (config.Block.columnCount == '2' || config.Block.columnCount == '3' || config.Block.columnCount == '4' || config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast3Columns: (config) => config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4' || config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast4Columns: (config) => config.Block && (config.Block.columnCount == '4' || config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast5Columns: (config) => config.Block && (config.Block.columnCount == '5' || config.Block.columnCount == '6'),
        hasAtLeast6Columns: (config) => config.Block && config.Block.columnCount == '6'
    }
};

export {
    Columns as Component,
    TypeConfig
};